const oktaConfig = {
  issuer: "https://exprealty.okta.com/oauth2/default",
  clientId: "0oa12xiu0bhrQZHb52p8",
  redirectUri: window.location.origin + "/login/callback",
  scopes: ["openid", "profile", "email"],
  pkce: true,
  requireAuth: true, // Enforce authentication for all users
};

export default oktaConfig;
